// extracted by mini-css-extract-plugin
export default {"num":"index_num_IU7rQ"};